import React from 'react';
import styled from 'styled-components';

const LegendList = styled.ul`
  list-style-type: none;
  font-size: 0.75rem;
  line-height: 1rem;
  li {
    display: inline-block;
    margin-right: 0.5rem;
    &:before {
      content: '';
      display: inline-block;
      background-color: black;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      margin-right: 0.125rem;
    }
    &:nth-of-type(1):before {background-color: rgba(89,136,157,0.25);  border: 1px solid rgba(89,136,157,1);}
    &:nth-of-type(2):before {background-color: rgba(157,186,115,0.25); border: 1px solid rgba(157,186,115,1);}
    &:nth-of-type(3):before {background-color: rgba(250,186,84,0.25); border: 1px solid rgba(250,186,84,1);}
    &:nth-of-type(4):before {background-color: rgba(234,33,45,0.25); border: 1px solid rgba(234,33,45,1);}
  }
`;

const OrtizLegend = () => (
  <LegendList className="legend legend-list benton-n4" id="ortiz-legend">
    <li>Solo</li>
    <li>Two-run</li>
    <li>Three-run</li>
    <li>Grand slam</li>
  </LegendList>
);

export default OrtizLegend;
